import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/invites')({
  component: () => <Outlet />,
})
